export default function (url = ''): string {
  if (url.startsWith('http') || url.startsWith('https')) {
    return url
  }
  return (process.env.VUE_APP_BASE_URL || '') + url
}
